export default __webpack_public_path__ + "/dist/images/voyager-contentimg.d3f17fe24cf4a84d996e9a03a5a7fe8a.png";